import { gql } from '@parkchirp/api-client';

export const GET_EMAIL_SENDER_ADDRESS = gql`
query getEmailSenderAddress(
    $facilityId: String!
  ) {
    getEmailSenderAddress(
        facilityId: $facilityId
    ) {
        id
        emailAddress
        isVerified
    }
  }
`;
